module.exports = __webpack_public_path__ + "img/Unit_Guide_pints.8b1ea682.svg";